import { APICore, API_URL } from './apiCore';
const api = new APICore();

const getAbTestsVariations = () => {
    return api.get(`${API_URL}/abTests/variations`);
};

export { getAbTestsVariations };
